import { SET_VEHICLE_DATA, SET_TOTAL_VEHICLES, REMOVE_VEHICLES, SET_VEHICLE_FILTER_DATA, SET_VEHICLE_PERCENTAGE, SET_TOTAL_FILTERED_VEHICLES } from "../types";

export const setVechiclesData = (data) => ({
    type: SET_VEHICLE_DATA,
    payload: data,
})

export const setVehiclePercentage = (data) => ({
    type: SET_VEHICLE_PERCENTAGE,
    payload: data,
})

export const setFilterVechiclesData = (data) => ({
    type: SET_VEHICLE_FILTER_DATA,
    payload: data,
})

export const setTotalVehicles = (totalVehicle) => ({
    type: SET_TOTAL_VEHICLES,
    payload: totalVehicle,
});

export const removeVechicles = () => {
    return {
        type: REMOVE_VEHICLES
    }
}


export const setTotalFilteredVehicles = (total) => ({
    type: SET_TOTAL_FILTERED_VEHICLES,
    payload: total
})